import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [Compass, AnimatedCompass] = createIcon({
  name: 'Compass',
  getIcon: (props) => (
    <Svg viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M9.99996 1.66666C5.39746 1.66666 1.66663 5.39749 1.66663 9.99999C1.66663 14.6025 5.39746 18.3333 9.99996 18.3333C14.6025 18.3333 18.3333 14.6025 18.3333 9.99999C18.3333 5.39749 14.6025 1.66666 9.99996 1.66666ZM14.105 6.98424L12.4933 11.0117C12.23 11.6692 11.71 12.1917 11.0541 12.4567L6.98829 14.1026C6.30579 14.3792 5.62496 13.7034 5.89496 13.0192L7.50329 8.93757C7.76912 8.26257 8.30495 7.72912 8.98079 7.46662L13.025 5.89253C13.7058 5.62669 14.3766 6.30424 14.105 6.98424ZM10.8333 9.99999C10.8333 10.46 10.46 10.8333 9.99996 10.8333C9.53996 10.8333 9.16663 10.46 9.16663 9.99999C9.16663 9.53999 9.53996 9.16666 9.99996 9.16666C10.46 9.16666 10.8333 9.53999 10.8333 9.99999Z"
        fill={'currentColor' ?? '#FF37C7'}
      />
    </Svg>
  ),
  defaultFill: '#FF37C7',
})
